var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-container"},[(_vm.message)?_c('div',{staticClass:"message-container"},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e(),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-bar"}),_c('div',{staticClass:"loading-bar"}),_c('div',{staticClass:"loading-bar"}),_c('div',{staticClass:"loading-bar"})])
}]

export { render, staticRenderFns }